import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface FlyerDataFailureProps extends BaseTemplateProps {
  flyerJobName: string
  partnerId: string
  retailerId: string
  flyerGroupKey: string
}

export const FlyerDataIngestionFailure: TemplateDefinition<FlyerDataFailureProps> = {
  renderParams: (props: FlyerDataFailureProps) => ({
    messageKey: 'notificationsDomain.templates.flyerDataIngestionFailure',
    values: {
      flyerJobName: props.flyerJobName,
    },
  }),
  getLink: (props: FlyerDataFailureProps): string => {
    if (!props) return ''
    const { partnerId, retailerId, flyerGroupKey } = props
    if (!partnerId || !retailerId || !flyerGroupKey) {
      return ''
    }
    return `/partners/${partnerId}/warehouses/${retailerId}/retailer-collections/flyers/review/${flyerGroupKey}`
  },
}
